import React from 'react';
import { StarIcon } from '@heroicons/react/24/solid';

interface StarRatingDisplayProps {
  rating: number;
  maxRating?: number;
  size?: number; // Size in pixels
  className?: string;
  starClassName?: string; // Optional class for individual stars
  filledColor?: string; // Tailwind color class for filled stars
  emptyColor?: string; // Tailwind color class for empty stars
}

const StarRatingDisplay: React.FC<StarRatingDisplayProps> = ({
  rating,
  maxRating = 5,
  size = 20, // Default size 20px (h-5 w-5)
  className = '',
  starClassName = '',
  filledColor = 'text-gold-300', // Default gold color
  emptyColor = 'text-primary-dark-300', // Default empty color
}) => {
  const validRating = Math.max(0, Math.min(rating, maxRating)); // Clamp rating
  const fullStars = Math.floor(validRating);
  const hasHalfStar = validRating % 1 >= 0.5;

  const stars = [];
  for (let i = 0; i < maxRating; i++) {
    let colorClass = emptyColor;
    if (i < fullStars) {
      colorClass = filledColor;
    } else if (i === fullStars && hasHalfStar) {
      // For simplicity, we'll render a full star with half opacity for half-ratings
      // A more complex solution could involve masking or custom SVG
      colorClass = `${filledColor}/60`; // Use opacity for half-star effect
    }

    stars.push(
      <StarIcon
        key={i}
        className={`inline-block ${colorClass} ${starClassName}`}
        style={{ width: `${size}px`, height: `${size}px` }}
      />
    );
  }

  return <div className={`flex items-center ${className}`}>{stars}</div>;
};

export default StarRatingDisplay;
